import { Column } from "src/components/tables/simpleTable";
import { isFieldWithValue, truncateText } from "src/utils";

export type DomainRows = Pick<
  Record<string, any>,
  | "host"
  | "certificateSecret"
  | "clusterName"
  | "environmentID"
  | "isUnsecure"
  | "certificateSecretName"
  | "certificateSecretNamespace"
>;

export const useDomainsRowsColumns = (): Column<DomainRows>[] => {
  const getSecurityStatus = (isUnsecure: boolean) => {
    if (isUnsecure) {
      return (
        <div className="text-[#FC2C2C] flex items-center font-medium">
          Disabled{" "}
          <i className="bi bi-x-lg text-[#FC2C2C] text-[10px] ml-1"></i>
        </div>
      );
    }
    return (
      <div className="text-[#2EA44F] flex items-center font-medium">
        Enabled <i className="bi bi-check-lg text-[#2EA44F] ml-1"></i>
      </div>
    );
  };

  const getScope = (environmentID: string) =>
    isFieldWithValue(environmentID) ? "Environment" : "Cluster";

  return [
    {
      title: "Host",
      field: "host",
      render: ({ host }) => <div>{truncateText(host, 25)}</div>,
    },
    {
      title: "Certificate Secret",
      field: "certificateSecretName",
      render: ({ certificateSecretNamespace, certificateSecretName }) => (
        <div
          title={
            certificateSecretName &&
            `${certificateSecretNamespace + "/" + certificateSecretName}`
              .length > 25
              ? `${certificateSecretNamespace + "/" + certificateSecretName}`
              : undefined
          }
        >
          {certificateSecretName?.length
            ? truncateText(
                certificateSecretNamespace + "/" + certificateSecretName,
                25
              )
            : "N/A"}
        </div>
      ),
    },
    {
      title: "Cluster",
      field: "clusterName",
      render: ({ clusterName }) => <div>{clusterName}</div>,
    },
    {
      title: "Scope",
      field: "scope",
      render: ({ environmentID }) => <>{getScope(environmentID)}</>,
    },
    {
      title: "Security",
      field: "isUnsecure",
      render: ({ isUnsecure }) => <>{getSecurityStatus(isUnsecure)}</>,
    },
  ];
};
